import React from "react";
import { Mail, LifeBuoy } from "lucide-react";
import PublicLayout from "../components/PublicLayout";

export default function SupportPage() {
  React.useEffect(() => {
    document.title = "Support | Bark Buddies";
  }, []);
  return (
    <PublicLayout>
      <section className="mx-auto max-w-2xl px-5 md:px-8 pt-16 md:pt-24 pb-24" data-testid="support-page">
        <div className="text-[12px] font-bold uppercase tracking-widest text-bark-teal">Help center</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-black tracking-tight text-bark-ink">
          We're here to help.
        </h1>
        <p className="mt-4 text-[16px] text-bark-ink2 leading-relaxed">
          Need help with Bark Buddies? Contact us for help with beta access,
          accounts, dog profiles, buddy requests, messaging, meetups, dog parks,
          safety reports, or account deletion.
        </p>

        <div className="mt-8 bg-white rounded-[28px] shadow-bark-soft p-6 md:p-10">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-2xl bg-bark-teal-soft grid place-items-center shrink-0">
              <LifeBuoy size={22} className="text-bark-teal" />
            </div>
            <div className="flex-1">
              <div className="text-[13px] font-bold uppercase tracking-widest text-bark-muted">
                Support email
              </div>
              <a
                href="mailto:support@barkbuddies.app"
                className="mt-1 block text-[20px] font-extrabold text-bark-ink hover:text-bark-teal transition-colors"
                data-testid="support-email-link"
              >
                support@barkbuddies.app
              </a>
              <p className="mt-3 text-[14px] text-bark-ink2 leading-relaxed">
                Typical response time: 1–2 business days. Please include your
                app version, device model, and a short description of the issue.
              </p>
              <a
                href="mailto:support@barkbuddies.app"
                className="mt-5 inline-flex items-center gap-2 rounded-full bg-bark-teal px-6 py-3 text-white font-extrabold text-[14px] shadow-bark-soft hover:bg-bark-teal-hover hover:-translate-y-0.5 transition-transform duration-200"
                data-testid="support-email-button"
              >
                <Mail size={16} />
                Email Support
              </a>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
